import axios from '../utils/axios';

export default function getBackgroundProcesses(adminId,params) {
    return (
        axios.get('/admin/' + adminId + '/background-process',{ params })
        .then(res => {
            return res.data
        })
        .catch(err => {
            return err;
        })
    )
}
